export enum OrderStatus {
  completed = "completed",
  cancelled = "cancelled",
  expired_confirmation = "expired_confirmation",
  rejected = "rejected",
  received = "received",
  arrived = "arrived",
  HALF_PREPARATION = "half_preparation",
  READY = "ready",
  SCHEDULED = "scheduled",
  PREPARING = "preparing",
}
